import api from './api';

/**
 * Custom Links API — thin wrapper around /api/custom-links.
 *
 * Placeholder substitution is done client-side at click time so a single
 * saved URL can serve every location without a per-location record.
 * Supported tokens:
 *   {location_id}      -> current switcher location's internal id
 *   {ghl_location_id}  -> current switcher location's GHL sub-account id
 *   {user_email}       -> logged-in user's email
 *   {user_id}          -> logged-in user's id
 *   {user_name}        -> logged-in user's display name
 */

/** Substitute placeholders in a URL string. Missing values become empty
 *  strings so a broken link fails obviously rather than sending the raw
 *  `{token}` characters through the wire. */
export function resolveCustomLinkUrl(rawUrl, ctx = {}) {
  if (!rawUrl) return '';
  const map = {
    '{location_id}': ctx.location?.id || '',
    '{ghl_location_id}': ctx.location?.ghl_location_id || '',
    '{user_email}': ctx.user?.email || '',
    '{user_id}': ctx.user?.id || '',
    '{user_name}': ctx.user?.name || ctx.user?.full_name || '',
  };
  let out = String(rawUrl);
  for (const [tok, val] of Object.entries(map)) {
    if (out.includes(tok)) {
      out = out.split(tok).join(encodeURIComponent(val));
    }
  }
  return out;
}

export const customLinksApi = {
  // Public: fetch the links visible for the current user + location
  listForUser: (locationId) =>
    api.get('/custom-links', { params: locationId ? { location_id: locationId } : {} }),

  // Admin
  adminList: () => api.get('/custom-links/admin/all'),
  adminCreate: (data) => api.post('/custom-links/admin', data),
  adminUpdate: (id, data) => api.put(`/custom-links/admin/${id}`, data),
  adminDelete: (id) => api.delete(`/custom-links/admin/${id}`),
};

export default customLinksApi;
